/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateChildMemoDto } from '../../models/update-child-memo-dto';

export interface ParentChildMemoControllerUpdateMemoByParent$Params {
  memoId: string;
      body: UpdateChildMemoDto
}

export function parentChildMemoControllerUpdateMemoByParent(http: HttpClient, rootUrl: string, params: ParentChildMemoControllerUpdateMemoByParent$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, parentChildMemoControllerUpdateMemoByParent.PATH, 'patch');
  if (params) {
    rb.path('memoId', params.memoId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

parentChildMemoControllerUpdateMemoByParent.PATH = '/api/child-memo/parent/{memoId}';
